/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../app/nls/StringResources'
], function (resources) {


	const TextEditorConstants = {

		FONT_FAMILY_CHOICES: [{
			//Make sure that the ID here matches css class name.
			'value': 'anton',
			'label': 'Anton',
			'cssClass': 'rt_fontFamilyAnton'
		}, {
			'value': 'cherrycreamsoda',
			'label': 'Cherry Cream Soda',
			'cssClass': 'rt_fontFamilyCherryCreamSoda'
		}, {
			'value': 'condiment',
			'label': 'Condiment',
			'cssClass': 'rt_fontFamilyCondiment-Regular'
		}, {
			'value': 'didactgothic',
			'label': 'Didact Gothic',
			'cssClass': 'rt_fontFamilyDidactGothic'
		}, {
			'value': 'euphoriascript',
			'label': 'Euphoria Script',
			'cssClass': 'rt_fontFamilyEuphoriaScript-Regular'
		}, {
			'value': 'helveticaneueforibm',
			'label': 'Helvetica Neue',
			'cssClass': 'rt_fontFamilyHelvNeueforIBM-Regular',
			'subCssClasses': [{
				'value': 'light',
				'label': resources.get('textFontFamilySubClassLight'),
				'cssClass': 'rt_fontFamilyHelvNeueforIBM-Light'
			}, {
				'value': 'lightitalic',
				'label': resources.get('textFontFamilySubClassLightItalic'),
				'cssClass': 'rt_fontFamilyHelvNeueforIBM-LightItalic'
			}, {
				'value': 'regular',
				'label': resources.get('textFontFamilySubClassRegular'),
				'cssClass': 'rt_fontFamilyHelvNeueforIBM-Regular'
			}, {
				'value': 'italic',
				'label': resources.get('textFontFamilySubClassItalic'),
				'cssClass': 'rt_fontFamilyHelvNeueforIBM-Italic'
			}, {
				'value': 'medium',
				'label': resources.get('textFontFamilySubClassMedium'),
				'cssClass': 'rt_fontFamilyHelvNeueforIBM-Medium'
			}, {
				'value': 'mediumitalic',
				'label': resources.get('textFontFamilySubClassMediumItalic'),
				'cssClass': 'rt_fontFamilyHelvNeueforIBM-MediumItalic'
			}, {
				'value': 'bold',
				'label': resources.get('textFontFamilySubClassBold'),
				'cssClass': 'rt_fontFamilyHelvNeueforIBM-Bold'
			}, {
				'value': 'bolditalic',
				'label': resources.get('textFontFamilySubClassBoldItalic'),
				'cssClass': 'rt_fontFamilyHelvNeueforIBM-BoldItalic'
			}]
		}, {
			'value': 'kaushanscript',
			'label': 'Kaushan Script',
			'cssClass': 'rt_fontFamilyKaushanScript-Regular'
		}, {
			'value': 'lobster',
			'label': 'Lobster',
			'cssClass': 'rt_fontFamilyLobster'
		}, {
			'value': 'merriweather',
			'label': 'Merriweather',
			'cssClass': 'rt_fontFamilyMerriweather-Regular',
			'subCssClasses': [{
				'value': 'italic',
				'label': resources.get('textFontFamilySubClassItalic'),
				'cssClass': 'rt_fontFamilyMerriweather-Italic'
			}, {
				'value': 'light',
				'label': resources.get('textFontFamilySubClassLight'),
				'cssClass': 'rt_fontFamilyMerriweather-Light'
			}, {
				'value': 'regular',
				'label': resources.get('textFontFamilySubClassRegular'),
				'cssClass': 'rt_fontFamilyMerriweather-Regular'
			}, {
				'value': 'bold',
				'label': resources.get('textFontFamilySubClassBold'),
				'cssClass': 'rt_fontFamilyMerriweather-Bold'
			}, {
				'value': 'bolditalic',
				'label': resources.get('textFontFamilySubClassBoldItalic'),
				'cssClass': 'rt_fontFamilyMerriweather-BoldItalic'
			}, {
				'value': 'black',
				'label': resources.get('textFontFamilySubClassBlack'),
				'cssClass': 'rt_fontFamilyMerriweather-Black'
			}, {
				'value': 'lightitalic',
				'label': resources.get('textFontFamilySubClassLightItalic'),
				'cssClass': 'rt_fontFamilyMerriweather-LightItalic'
			}, {
				'value': 'heavyitalic',
				'label': resources.get('textFontFamilySubClassHeavyItalic'),
				'cssClass': 'rt_fontFamilyMerriweather-HeavyItalic'
			}]
		}, {
			'value': 'merriweathersans',
			'label': 'Merriweather Sans',
			'cssClass': 'rt_fontFamilyMerriweatherSans-Regular',
			'subCssClasses': [{
				'value': 'italic',
				'label': resources.get('textFontFamilySubClassItalic'),
				'cssClass': 'rt_fontFamilyMerriweatherSans-Italic'
			}, {
				'value': 'light',
				'label': resources.get('textFontFamilySubClassLight'),
				'cssClass': 'rt_fontFamilyMerriweatherSans-Light'
			}, {
				'value': 'lightitalic',
				'label': resources.get('textFontFamilySubClassLightItalic'),
				'cssClass': 'rt_fontFamilyMerriweatherSans-LightItalic'
			}, {
				'value': 'regular',
				'label': resources.get('textFontFamilySubClassRegular'),
				'cssClass': 'rt_fontFamilyMerriweatherSans-Regular'
			}, {
				'value': 'bold',
				'label': resources.get('textFontFamilySubClassBold'),
				'cssClass': 'rt_fontFamilyMerriweatherSans-Bold'
			}, {
				'value': 'bolditalic',
				'label': resources.get('textFontFamilySubClassBoldItalic'),
				'cssClass': 'rt_fontFamilyMerriweatherSans-BoldItalic'
			}, {
				'value': 'extrabold',
				'label': resources.get('textFontFamilySubClassExtraBold'),
				'cssClass': 'rt_fontFamilyMerriweatherSans-ExtraBold'
			}, {
				'value': 'extrabolditalic',
				'label': resources.get('textFontFamilySubClassExtraBoldItalic'),
				'cssClass': 'rt_fontFamilyMerriweatherSans-ExtraBoldItalic'
			}]
		}, {
			'value': 'monoton',
			'label': 'Monoton',
			'cssClass': 'rt_fontFamilyMonoton-Regular'
		}, {
			'value': 'montserrat',
			'label': 'Montserrat',
			'cssClass': 'rt_fontFamilyMontserrat-Regular',
			'subCssClasses': [{
				'value': 'hairline',
				'label': resources.get('textFontFamilySubClassHairline'),
				'cssClass': 'rt_fontFamilyMontserrat-Hairline'
			}, {
				'value': 'light',
				'label': resources.get('textFontFamilySubClassLight'),
				'cssClass': 'rt_fontFamilyMontserrat-Light'
			}, {
				'value': 'regular',
				'label': resources.get('textFontFamilySubClassRegular'),
				'cssClass': 'rt_fontFamilyMontserrat-Regular'
			}, {
				'value': 'bold',
				'label': resources.get('textFontFamilySubClassBold'),
				'cssClass': 'rt_fontFamilyMontserrat-Bold'
			}, {
				'value': 'black',
				'label': resources.get('textFontFamilySubClassBlack'),
				'cssClass': 'rt_fontFamilyMontserrat-Black'
			}]
		}, {
			'value': 'opensanscondensed',
			'label': 'Open Sans Condensed',
			'cssClass': 'rt_fontFamilyOpenSansCondensed-Light',
			'subCssClasses': [{
				'value': 'light',
				'label': resources.get('textFontFamilySubClassLight'),
				'cssClass': 'rt_fontFamilyOpenSansCondensed-Light'
			}, {
				'value': 'lightitalic',
				'label': resources.get('textFontFamilySubClassLightItalic'),
				'cssClass': 'rt_fontFamilyOpenSansCondensed-LightItalic'
			}, {
				'value': 'bold',
				'label': resources.get('textFontFamilySubClassBold'),
				'cssClass': 'rt_fontFamilyOpenSansCondensed-Bold'
			}]
		}, {
			'value': 'oswald',
			'label': 'Oswald',
			'cssClass': 'rt_fontFamilyOswald-Regular',
			'subCssClasses': [{
				'value': 'extralight',
				'label': resources.get('textFontFamilySubClassExtraLight'),
				'cssClass': 'rt_fontFamilyOswald-ExtraLight'
			}, {
				'value': 'extralightitalic',
				'label': resources.get('textFontFamilySubClassExtraLightItalic'),
				'cssClass': 'rt_fontFamilyOswald-ExtraLightItalic'
			}, {
				'value': 'light',
				'label': resources.get('textFontFamilySubClassLight'),
				'cssClass': 'rt_fontFamilyOswald-Light'
			}, {
				'value': 'lightitalic',
				'label': resources.get('textFontFamilySubClassLightItalic'),
				'cssClass': 'rt_fontFamilyOswald-LightItalic'
			}, {
				'value': 'regular',
				'label': resources.get('textFontFamilySubClassRegular'),
				'cssClass': 'rt_fontFamilyOswald-Regular'
			}, {
				'value': 'regularitalic',
				'label': resources.get('textFontFamilySubClassRegularItalic'),
				'cssClass': 'rt_fontFamilyOswald-RegularItalic'
			}, {
				'value': 'medium',
				'label': resources.get('textFontFamilySubClassMedium'),
				'cssClass': 'rt_fontFamilyOswald-Medium'
			}, {
				'value': 'mediumitalic',
				'label': resources.get('textFontFamilySubClassMediumItalic'),
				'cssClass': 'rt_fontFamilyOswald-MediumItalic'
			}, {
				'value': 'demibold',
				'label': resources.get('textFontFamilySubClassDemiBold'),
				'cssClass': 'rt_fontFamilyOswald-DemiBold'
			}, {
				'value': 'demibolditalic',
				'label': resources.get('textFontFamilySubClassDemiBoldItalic'),
				'cssClass': 'rt_fontFamilyOswald-DemiBoldItalic'
			}, {
				'value': 'bold',
				'label': resources.get('textFontFamilySubClassBold'),
				'cssClass': 'rt_fontFamilyOswald-Bold'
			}, {
				'value': 'bolditalic',
				'label': resources.get('textFontFamilySubClassBoldItalic'),
				'cssClass': 'rt_fontFamilyOswald-BoldItalic'
			}, {
				'value': 'heavy',
				'label': resources.get('textFontFamilySubClassHeavy'),
				'cssClass': 'rt_fontFamilyOswald-Heavy'
			}, {
				'value': 'heavyitalic',
				'label': resources.get('textFontFamilySubClassHeavyItalic'),
				'cssClass': 'rt_fontFamilyOswald-HeavyItalic'
			}, {
				'value': 'stencil',
				'label': resources.get('textFontFamilySubClassStencil'),
				'cssClass': 'rt_fontFamilyOswald-Stencil'
			}]
		}, {
			'value': 'playball',
			'label': 'Playball',
			'cssClass': 'rt_fontFamilyPlayball'
		}, {
			'value': 'ibmplexsans',
			'label': 'IBM Plex',
			default: true,
			'cssClass': 'rt_fontFamilyPlex-Regular',
			'subCssClasses': [{
				'value': 'light',
				'label': resources.get('textFontFamilySubClassLight'),
				'cssClass': 'rt_fontFamilyPlex-Light'
			}, {
				'value': 'lightitalic',
				'label': resources.get('textFontFamilySubClassLightItalic'),
				'cssClass': 'rt_fontFamilyPlex-LightItalic'
			}, {
				'value': 'regular',
				'label': resources.get('textFontFamilySubClassRegular'),
				'cssClass': 'rt_fontFamilyPlex-Regular'
			}, {
				'value': 'italic',
				'label': resources.get('textFontFamilySubClassItalic'),
				'cssClass': 'rt_fontFamilyPlex-Italic'
			}, {
				'value': 'medium',
				'label': resources.get('textFontFamilySubClassMedium'),
				'cssClass': 'rt_fontFamilyPlex-Medium'
			}, {
				'value': 'mediumitalic',
				'label': resources.get('textFontFamilySubClassMediumItalic'),
				'cssClass': 'rt_fontFamilyPlex-MediumItalic'
			}, {
				'value': 'bold',
				'label': resources.get('textFontFamilySubClassBold'),
				'cssClass': 'rt_fontFamilyPlex-Bold'
			}, {
				'value': 'bolditalic',
				'label': resources.get('textFontFamilySubClassBoldItalic'),
				'cssClass': 'rt_fontFamilyPlex-BoldItalic'
			}]
		}, {
			'value': 'roboto',
			'label': 'Roboto',
			'cssClass': 'rt_fontFamilyRoboto-Regular',
			'subCssClasses': [{
				'value': 'thin',
				'label': resources.get('textFontFamilySubClassThin'),
				'cssClass': 'rt_fontFamilyRoboto-Thin'
			}, {
				'value': 'thinitalic',
				'label': resources.get('textFontFamilySubClassThinItalic'),
				'cssClass': 'rt_fontFamilyRoboto-ThinItalic'
			}, {
				'value': 'light',
				'label': resources.get('textFontFamilySubClassLight'),
				'cssClass': 'rt_fontFamilyRoboto-Light'
			}, {
				'value': 'lightitalic',
				'label': resources.get('textFontFamilySubClassLightItalic'),
				'cssClass': 'rt_fontFamilyRoboto-LightItalic'
			}, {
				'value': 'regular',
				'label': resources.get('textFontFamilySubClassRegular'),
				'cssClass': 'rt_fontFamilyRoboto-Regular'
			}, {
				'value': 'italic',
				'label': resources.get('textFontFamilySubClassItalic'),
				'cssClass': 'rt_fontFamilyRoboto-Italic'
			}, {
				'value': 'medium',
				'label': resources.get('textFontFamilySubClassMedium'),
				'cssClass': 'rt_fontFamilyRoboto-Medium'
			}, {
				'value': 'mediumitalic',
				'label': resources.get('textFontFamilySubClassMediumItalic'),
				'cssClass': 'rt_fontFamilyRoboto-MediumItalic'
			}, {
				'value': 'bold',
				'label': resources.get('textFontFamilySubClassBold'),
				'cssClass': 'rt_fontFamilyRoboto-Bold'
			}, {
				'value': 'bolditalic',
				'label': resources.get('textFontFamilySubClassBoldItalic'),
				'cssClass': 'rt_fontFamilyRoboto-BoldItalic'
			}, {
				'value': 'black',
				'label': resources.get('textFontFamilySubClassBlack'),
				'cssClass': 'rt_fontFamilyRoboto-Black'
			}, {
				'value': 'blackitalic',
				'label': resources.get('textFontFamilySubClassBlackItalic'),
				'cssClass': 'rt_fontFamilyRoboto-BlackItalic'
			}]
		}, {
			'value': 'sortsmillgoudy',
			'label': 'Sorts Mill Goudy',
			'cssClass': 'rt_fontFamilySortsMillGoudy-Regular',
			'subCssClasses': [{
				'value': 'regular',
				'label': resources.get('textFontFamilySubClassRegular'),
				'cssClass': 'rt_fontFamilySortsMillGoudy-Regular'
			}, {
				'value': 'italic',
				'label': resources.get('textFontFamilySubClassItalic'),
				'cssClass': 'rt_fontFamilySortsMillGoudy-Italic'
			}]
		}, {
			'value': 'specialelite',
			'label': 'Special Elite',
			'cssClass': 'rt_fontFamilySpecialElite'
		}],

		FONT_SIZE_CHOICES: [{
			'value': 'auto',
			'label': resources.get('textAutoFontSize')
		}, {
			'value': '8',
			'label': '8'
		}, {
			'value': '9',
			'label': '9'
		}, {
			'value': '10',
			'label': '10'
		}, {
			'value': '11',
			'label': '11'
		}, {
			'value': '12',
			'label': '12'
		}, {
			'value': '14',
			'label': '14'
		}, {
			'value': '16',
			'label': '16'
		}, {
			'value': '18',
			'label': '18'
		}, {
			'value': '20',
			'label': '20'
		}, {
			'value': '22',
			'label': '22'
		}, {
			'value': '24',
			'label': '24'
		}, {
			'value': '26',
			'label': '26'
		}, {
			'value': '28',
			'label': '28'
		}, {
			'value': '30',
			'label': '30'
		}, {
			'value': '36',
			'label': '36'
		}, {
			'value': '48',
			'label': '48'
		}, {
			'value': '60',
			'label': '60'
		}, {
			'value': '72',
			'label': '72'
		}, {
			'value': '96',
			'label': '96'
		}, {
			'value': '120',
			'label': '120'
		}, {
			'value': '170',
			'label': '170'
		}, {
			'value': '230',
			'label': '230'
		}]
	};

	return TextEditorConstants;
});
